


<div class="card cardsmall">
    <div class="grid grid-nogutter flex-wrap gap-3 p-fluid">
        <div class="col-12 pl-2">
            <form [formGroup]="form">
                <p-tabView> 
                    <p-tabPanel header="{{lang.el('Ticket')}}">
                        <div class="formgrid">       
                            <formly-form [model]="model" 
                            [fields]="tabsFields[0].fields" 
                            [options]="options" 
                            [form]="form"></formly-form>                     
                        </div>
                    </p-tabPanel>
                    <p-tabPanel header="Allegati" *ngIf="action!='new'"> 
                         <div class="grid grid-nogutter flex-wrap gap-3 p-fluid">
                            <div class="col-12">
                                <p-table #maintable 
                                    [value]="attachments" 
                                    dataKey="id" 
                                    [rows]="10" 
                                    [rowHover]="true" 
                                    styleClass="p-datatable-gridlines" 
                                    [paginator]="false" 
                                    responsiveLayout="scroll">
                                    
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th style="min-width: 12rem">
                                                    File
                                            </th>
                                            <th style="text-align:center;">    
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-att>
                                        <tr>
                                            <td>
                                                {{att.filename}}
                                            </td>
                                            <td>
                                               <a target=_blank href="{{geturl(att.filename)}}">download</a>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                            <div class="col-12">
                                <p-fileUpload 
                                    name="attachments[]" 
                                    [url]="urlapi" 
                                    (onBeforeSend)="onBeforeSend($event)" 
                                    (onUpload)="onUpload($event)" 
                                    [multiple]="true" 
                                    maxFileSize="10000000"> 
                                </p-fileUpload>

                            </div>
                         </div>
                    </p-tabPanel>
                </p-tabView>
            </form>
        </div>
    </div>
</div>
<div class="grid">
    <div class="col-12">
        <div class="flex-1 w-full lg:w-3 xl:w-4 flex flex-column row-gap-3">
            <div class="flex flex-column sm:flex-row gap-3 py-2">
                <button
                pButton pRipple class="p-button-danger flex-1 p-button-outlined" 
                (click)="annulla()"
                label="{{lang.el('Annulla')}}"></button>
                <button  *ngIf="action!='delete'"
                pButton pRipple class="p-button-primary flex-1 border-round" 
                (click)="save()"
                [disabled]="!form.valid"
                label="{{lang.el('Salva')}}" icon="pi pi-fw pi-check"></button>
            </div>
        </div>
    </div>
</div>
<p-toast></p-toast>

